import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

var app = new Vue({
    el: '#page-container',
    delimiters: ['${', '}'],
    
    components: {
        VueSlickCarousel,
    },

    data: () => ({
        showSearch: false,

        slickOptions: {

            infinite: true,
            slidesToShow: 1,
            arrows: false,
            dots: true,

        },
        
        slickEditionsOptions: {
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            infinite: true,
            responsive: [

                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },

            ]

        },

        slickInstagramOptions: {
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 2,
            arrows: true,
            autoplay: false,
            infinite: false,
            responsive: [

                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },

            ]

        },

        menuOpen: false,

        activeTab: 0,
    }),

    mounted() {

        $('.page-wrap').on('click', (e) => {
            this.desktopReset();
        });

        let landing = document.getElementById('cta-landing');


        if (landing !== undefined) {
            setTimeout(() => {
                document.getElementById('cta-landing').style.opacity = '0';
                document.getElementById('cta-landing').style.display = 'none';
            }, 2000);
        }
    },

    methods: {
        scrollToTop() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });


        },

        toggleMenu() {
            this.menuOpen = !this.menuOpen;
        },

        toggleSearch() {
            this.showSearch = !this.showSearch;
        },


        desktopReset() {
            this.showSearch = false;
        },
    },

})